module.exports = __webpack_public_path__ + "static/background2-004a376b5b74f5ff17b35136c7df3d4c.svg";